<template>
  <div id="SocialList">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">群組列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">社交動態</li>
              <li class="breadcrumb-item active">群組列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-banner" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-10">
            <div class="b-filter">
              <el-button @click="$router.push({ name: 'adminSociaCloseGroup' })"
                >已關閉群組</el-button
              >
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs"></div>
              <div class="card-body">
                <el-table
                  :data="GetList"
                  v-loading="loading"
                  border
                  row-key="id"
                >
                  <el-table-column width="200" label="操作">
                    <template slot-scope="scope">
                      <el-button type="text" @click="close(scope.row)">
                        關閉群組
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column label="群主名稱" prop="sgL_CreateName">
                  </el-table-column>
                  <el-table-column label="群組名稱" prop="sgL_GroupName">
                    <template slot-scope="scope">
                      <a href="javascript:;" @click="goGroup(scope.row)">{{
                        scope.row.sgL_GroupName
                      }}</a>
                    </template>
                  </el-table-column>
                  <el-table-column label="最近一個發佈內容" prop="" width="300">
                    <template slot-scope="scope">
                      <span>{{ scope.row.sgL_Content }}</span>
                      <img
                        v-for="(item, ix) in scope.row.sgL_GroupImageTemplS"
                        :key="ix"
                        :src="item"
                        style="width: 60px; height: 60px; margin: 5px"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="朋友"
                    prop="friendCount"
                  ></el-table-column>
                  <el-table-column
                    label="瀏覽"
                    prop="sgL_PG_CTotalView"
                  ></el-table-column>
                  <el-table-column
                    label="留言"
                    prop="messageCount"
                  ></el-table-column>
                  <el-table-column
                    label="相簿"
                    prop="photoCount"
                  ></el-table-column>
                  <el-table-column
                    label="影片"
                    prop="videoCount"
                  ></el-table-column>
                  <el-table-column
                    label="分享"
                    prop="sgL_SharCount"
                  ></el-table-column>
                  <el-table-column
                    label="建立時間"
                    prop="sgL_UpdateTimeS"
                  ></el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
            <div class="row">
              <div class="col-lg-4 offset-lg-7">
                <!--  引用分页组件 -->
                <pagination
                  v-if="pageParams.pageshow"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  data() {
    return {
      SGL_IsShow: false,
      SGL_Type: -1,
      SocialList: null,
      pageParams: {
        pageshow: true,
        currentPage: 1, //當前頁
        total: 0, //總條數
        limit: 10, //顯示條數
      },
      loading: true,
    };
  },
  created() {
    this.getSocialList();
  },
  watch: {
    SGL_Type: {
      handler(newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.handleCurrentChange(1);
        }
      },
    },
    SGL_IsShow: {
      handler(newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.handleCurrentChange(1);
        }
      },
    },
  },
  methods: {
    goGroup(item) {
      let routeUrl = this.$router.resolve({
        name: "feedGroup_FeedGroupDetail",
        query: {
          sgL_GroupId: item.id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    Look(item) {
      this.$router.push({ name: "feed", query: { id: item.id } });
    },
    getSocialList() {
      this.loading = true;
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        SGL_Status: 1,
      };
      this.$api.social
        .AdminGroupGetAllList(params)
        .then((res) => {
          if (res.data.success) {
            this.SocialList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch()
        .then((obj) => {
          this.loading = false;
        });
    },
    close(item) {
      let params = {
        GroupId: item.id,
        Remark: "",
      };
      this.$prompt(
        `關閉後，所有人皆無法看到該群組及進入查看內容。管理員可從後臺將群組改回開放狀態。`,
        "確認關閉群組？",
        {
          confirmButtonText: "是，請關閉",
          cancelButtonText: "取消",
        }
      ).then(({ value }) => {
        params.Remark = value;
        this.Update(params);
      });
    },
    Update(params) {
      this.$api.social
        .AdminGroupUpdateStatus(params)
        .then((res) => {
          if (res.data.success) {
            this.getSocialList();
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch()
        .then((obj) => {
          this.loading = false;
        });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getSocialList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getSocialList();
    },
  },
  components: {
    pagination,
  },
  computed: {
    GetList() {
      return this.SocialList;
    },
  },
};
</script>

<style scoped>
.filter .current {
  background-color: #2e3e4a;
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminSocial/group.vue